<template>
  <div class="w-100">
    <div class="marketplace-widget-container container mb-6 px-5">
      <div class="row">
        <div class="col-6">
          <TrustpilotWidget
            :width="trustpilotSizes.width"
            :height="trustpilotSizes.height"
          />
        </div>
        <div class="col-6 pt-2">
          <BbbWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrustpilotWidget from '~/components/TrustpilotWidget'
import BbbWidget from '~/components/BbbWidget.vue'

export default {
  name: 'MarketplaceWidgets',
  props: ['view'],
  components: {
    TrustpilotWidget,
    BbbWidget
  },
  computed: {
    trustpilotSizes() {
      if (this.view === 'desktop') {
        return { height: 75, width: 100 }
      } else {
        return { height: 90, width: 140 }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
